import { createReducer } from 'redux-starter-kit';
import {selectRequest} from "../../domain/requests/RequestReducer";
import {
  cancelCreateCredits, createCredits,
  fetchAllBucketBalances,
  fetchAllCredits,
  saveCreditAllocation
} from "./customerCreditsUiActions";


export const submitCreditAllocationRequest = (state) => {
  const requestId = state.via.ui.creditBalances.editState.submitCreditAllocationId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

export const selectCreditBalancesRequest = (state) => {
  const requestId = state.via.ui.creditBalances.fetchCreditBalancesRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

export const selectBucketBalancesRequest = (state) => {
  const requestId = state.via.ui.bucketBalances.fetchBucketBalancesRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for finding the current edit state.
 * @param {object} state The redux state for the application.
 * @returns An object containing details about the bucket being edited.
 * @example const editState = selectEditState(state);
 */
export const selectEditState = state => state.via.ui.creditBalances.editState;

const initialEditingState = {
  isEditing: false,
  code: null,
  fetchCreditBalancesRequestId: null,
  validationMessages: ({
    title: '',
    messages: [],
    visible: false,
  }),
};

const creditBalancesInitialState = {
  editState: initialEditingState,
  submitCreditAllocationId: null,
};

/**
 * A reducer for handling the UI state changes for the credit allocation screen.
 */
const customerCreditsUiReducer = createReducer(creditBalancesInitialState, {

  [createCredits]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      isEditing: true,
      code: action.payload,
    },
  }),

  [cancelCreateCredits]: state => ({
    ...state,
    editState: {
      ...initialEditingState,
    },
  }),

  [saveCreditAllocation]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      submitCreditAllocationId: action.payload,
    },
  }),

  [fetchAllCredits]: (state, action) => ({
    ...state,
    fetchCreditBalancesRequestId: action.payload,
  }),

  [fetchAllBucketBalances]: (state, action) => ({
    ...state,
    fetchBucketBalancesRequestId: action.payload,
  }),

});

export default customerCreditsUiReducer;
